import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Seo from "./components/Seo";

import Home from "./pages/Home";
import About from "./pages/About";
import Features from "./pages/Features";
import Coaching from "./pages/Coaching";
import WorkoutTracking from "./pages/WorkoutTracking";
import Nutrition from "./pages/Nutrition";
import SmartScale from "./pages/SmartScale";
import KingdomScore from "./pages/KingdomScore";
import KingdomInsights from "./pages/KingdomInsights";
import BusinessPartnerships from "./pages/BusinessPartnerships";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import Terms from "./pages/legal/Terms";
import CookiePolicy from "./pages/legal/CookiePolicy";
import GDPR from "./pages/legal/GDPR";
import AccountDeletion from "./pages/legal/AccountDeletion";

function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
      <Seo title="Page Not Found" path="/404" />
      <p className="font-heading text-7xl font-semibold text-gold-gradient">404</p>
      <h1 className="mt-4 font-heading text-2xl text-white">This page doesn't exist</h1>
      <p className="mt-3 text-zinc-400">The page you're looking for may have moved.</p>
      <Link to="/" className="btn-primary mt-8" data-testid="notfound-home">
        Back to Home
      </Link>
    </div>
  );
}

export default function App() {
  return (
    <div className="relative min-h-screen bg-[#050505]">
      <ScrollToTop />
      <Navbar />
      <main className="relative z-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/features" element={<Features />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/workout-tracking" element={<WorkoutTracking />} />
          <Route path="/nutrition" element={<Nutrition />} />
          <Route path="/smart-scale" element={<SmartScale />} />
          <Route path="/kingdom-score" element={<KingdomScore />} />
          <Route path="/kingdom-insights" element={<KingdomInsights />} />
          <Route path="/business-partnerships" element={<BusinessPartnerships />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<Terms />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/gdpr" element={<GDPR />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
